module.exports = __webpack_public_path__ + "static/media/slide1.472de18a.jpg";